// extracted by mini-css-extract-plugin
export default {"compact-navbar":"LightNav_compact-navbar__xv8Qy","navbar-links":"LightNav_navbar-links__CET7H"};